import React from 'react'
import Image from "next/image";
import Head from "next/head";
import styles from "../sch-test/delhi-prefit.module.css";
import csatWebBanner from "../../assets/images/upsc/All-India-Open-Mock-Test-Web-Banner.jpg";
import csatMobBanner from "../../assets/images/upsc/All-India-Open-Mock-Test-Mobile-Banner.jpg";
import Navbar from '../../components/Navbar/Navbar';
import Footer from '../../components/Footer/Footer';
import Link from "next/link";
import { useState,useEffect } from 'react';
import Form from "./centerform";
import {useRouter} from 'next/router';

const allIndiaPrelimsMockTestSeries = () => {

   const feestructure3 =[

    {Date: "7th Aug 2026",
          Day: (<><div>Friday</div></>),
         Time: (<><div>	9:00 am to 12:00 pm</div></>),
        Paper: (<><div>	Essay Mock</div></>),
      Subject: (<><div>Essay</div></>), 
    },

    {Date: "8th Aug 2026",
          Day: (<><div>Saturday</div></>),
         Time: (<><div>	9:00 am to 12:00 pm</div></>),
        Paper: (<><div>	GS I Mock</div></>),
      Subject: (<><div>GS I - Full Portions</div></>), 
    },

    {Date: "8th Aug 2026",
          Day: (<><div>Saturday</div></>),
         Time: (<><div>2:30 pm to 5:30 pm</div></>),
        Paper: (<><div>	GS II Mock</div></>),
      Subject: (<><div>GS II - Full Portions</div></>), 
    },

    {Date: "9th Aug 2026",
          Day: (<><div>Sunday</div></>),
         Time: (<><div>9:00 am to 12:00 pm</div></>),
        Paper: (<><div>	GS III Mock</div></>),
      Subject: (<><div>GS III - Full Portions</div></>), 
    },

    {Date: "9th Aug 2026",
          Day: (<><div>Sunday</div></>),
         Time: (<><div>2:30 pm to 5:30 pm</div></>),
        Paper: (<><div>	GS IV Mock</div></>),
      Subject: (<><div>GS IV - Full Portions</div></>), 
    },

    {Date: "10th Aug 2026",
          Day: (<><div>Monday</div></>),
         Time: (<><div>9:00 am to 12:00 pm</div></>),
        Paper: (<><div>Compulsory English Mock</div></>),
      Subject: (<><div>Self Evaluation</div></>), 
    },

    {Date: "10th Aug 2026",
          Day: (<><div>Monday</div></>),
         Time: (<><div>2:30 pm to 5:30 pm</div></>),
        Paper: (<><div>	Compulsory Regional Language Mock</div></>),
      Subject: (<><div>For Tamil,Malayalam,Hindi,Kannada Only. Self Evaluation</div></>), 
    },

    {Date: "11th Aug 2026",
          Day: (<><div>Tuesday</div></>),
         Time: (<><div>9:00 am to 12:00 pm</div></>),
        Paper: (<><div>Optional Subject - Paper 1 Mock</div></>),
      Subject: (<><div>Full Portions (Agriculture, Anthropology, Economics, English Literature, Geography, History, Kannada Literature, Law, Malayalam Literature, Mathematics, Medical Science, Political Science, Psychology, Public Administration,Sociology,Tamil Literature) [Key and Evaluation varies according to the subjects. Refer Optional Detailed schedule]</div></>), 
    },

    {Date: "11th Aug 2026",
          Day: (<><div>Tuesday</div></>),
         Time: (<><div>2:30 pm to 5:30 pm</div></>),
        Paper: (<><div>	Optional Subject - Paper 2 Mock</div></>),
      Subject: (<><div>Full Portions (Agriculture, Anthropology, Economics, English Literature, Geography, History, Kannada Literature, Law, Malayalam Literature, Mathematics, Medical Science, Political Science, Psychology, Public Administration,Sociology,Tamil Literature) [Key and Evaluation varies according to the subjects. Refer Optional Detailed schedule]</div></>), 
    },


    ]
      const jsonLd ={
        "@context": "https://schema.org",
        "@type": "WebPage",
        "name": "UPSC All India Mains Mock Test 2026",
        "url": "https://www.shankariasacademy.com/upsc-all-india-mains-mock-test/",
        "description": "Register for UPSC All India Mains Mock Test 2026 at Shankar IAS Academy. Get detailed feedback, expert evaluation & boost your Mains exam strategy."
      }
     
  return (
        <>

            <Head>
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd,null, "\t") .replaceAll("],\n\t\"", "],\n\n\t\"") }} />
                <meta charset="UTF-8" />
                <link rel="icon" href="./logo.png" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <meta name="robots" content="noodp,noydir" />
                <meta name="robots" content="index,follow" />
                <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
                <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
                <meta property="article:modified_time" content="2026-07-25T05:43:44+00:00" />
                <title>UPSC All India Mains Mock Test 2026</title>
                <meta name="title" content="UPSC All India Mains Mock Test 2026" />
                <meta name="description" content=" Register for UPSC All India Mains Mock Test 2026 at Shankar IAS Academy. Get detailed feedback, expert evaluation & boost your Mains exam strategy." />
				<meta name="keywords" content="UPSC All India Mains Mock Test, SIA All India Mains Mock Test, All India UPSC Mains Mock Test, UPSC Mains Mock Test, Free All India Mains Mock Test, Mock Test for UPSC Free, Free Mock Test for UPSC Mains" />
                <link rel="canonical" href="https://www.shankariasacademy.com/upsc-all-india-mains-mock-test" />
                <meta property="og:locale" content="en_US" />
                <meta property="og:type" content="article" />
                <meta property="og:title" content="UPSC All India Mains Mock Test 2026" />
                <meta property="og:description" content=" Register for UPSC All India Mains Mock Test 2026 at Shankar IAS Academy. Get detailed feedback, expert evaluation & boost your Mains exam strategy." />
                <meta property="og:url" content="https://www.shankariasacademy.com/upsc-all-india-mains-mock-test"/>
                <meta property="og:site_name" content="Shankar IAS Academy" />
                <meta name="twitter:card" content="summary_large_image" />
                <meta name="twitter:site" content="@shankarias" />
            </Head>

            <Navbar title="sch-test"/>

            <div className="container">
                <div className='row'>
                    <div className='col'>
                       <h1 className={`${styles.pagemaintitle}`}>UPSC All India Mains Mock Test 2026</h1>
                    </div>
                </div>
             <div className='row pt-2 d-none d-md-block'>
                    <div className='col'>
                        <Image src={csatWebBanner} className="img-fluid w-100" alt="Free All India Mains Mock Test" title="Free All India Mains Mock Test" />
                    </div>
                </div>
                <div className='row pt-4 d-block d-md-none'>
                    <div className='col'>
                        <Image src={csatMobBanner} className="img-fluid w-100" alt="Free All India Mains Mock Test" title="Free All India Mains Mock Test" />
                    </div>
                </div> 
            </div>


            <div className="container-fluid pt-2" style={{ background: "#FFF2F2 0% 0% no-repeat padding-box", opacity: "1" }}>
                <div className="row mx-auto pt-3" >
                    <h2 className={`${styles.sectiontitle} pt-3 text-center`}> Registration for All India Mains Mock Test</h2>
               </div>

               <div style={{ display: "flex", justifyContent: "center" }}>
                    <Link href="https://forms.gle/XwcixrJ21mYa7wtHA" target="_blank">
                    <button className={`${styles.normalbutton} text-center`} type="button">
                        Register Now
                    </button>
                    </Link>
                </div>
                <p className="p-2 text-center" > <span className={`${styles.dot}`}>*</span>Only the GS Papers (GS 1, 2, 3, 4) and Essay Paper of mains-qualified students were evaluated. </p>
            </div>  
                    
            <div className="container-fluid " style={{background: '#F4F6F8'}}>   
                <section  id="courseandfees">
                <div className="container " >
                    <h2 className={`${styles.scheduletitle}  `}> Mock Test schedule : </h2>
                    <div className="row">
                            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#b50507" }}>Date</div>
                            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Day</div>
                            <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#b50507" }}>Time</div>
                            <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Paper</div>
                            <div className={`${styles.tableheading} col-12 col-md-3 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#b50507" }}>Subject</div>
                            
                            <hr/>
                    </div>
                            
                    {feestructure3.map((item,index)=>(
                        <div className={`${styles.facultyborder3} row`}>
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Date</div>
                                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.Date}</div>
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Day</div>
                                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0  pb-md-3`}>{item.Day}</div>
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Time</div>
                                    <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.Time}</div>
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Paper</div>
                                    <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-0`}>{item.Paper}</div>
                            <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Subject</div>
                                    <div className={`${styles.classacheiverrank} col-8 col-md-3 mb-0 text-center pt-2 pt-md-0`}>{item.Subject}</div>
                            
                                <hr/>
                        </div>
                            ))} 
                        </div>
                </section>
            </div>

    <Footer />
        </>
    )
}

export default allIndiaPrelimsMockTestSeries;